import type { ProductItemPriority, ProductItemStage } from './types';

export const STAGE_LABELS: Record<ProductItemStage, string> = {
  ideas: 'Ideas',
  prioritized: 'Prioritized',
  in_development: 'In Development',
  dogfooding: 'Dogfooding',
  beta: 'Beta',
  on_hold: 'On Hold',
  ga: 'GA',
  internal: 'Internal',
  deprecated: 'Deprecated',
};

/**
 * Ordered list of stages rendered as columns, left-to-right. `internal` is a
 * side-track (long-lived internal-only products), parked at the far right of
 * the active path, just before Deprecated.
 */
export const ACTIVE_STAGES: ProductItemStage[] = [
  'ideas',
  'prioritized',
  'in_development',
  'dogfooding',
  'beta',
  'on_hold',
  'ga',
  'internal',
];

export const ALL_STAGES: ProductItemStage[] = [...ACTIVE_STAGES, 'deprecated'];

export const STAGE_ACCENT: Record<ProductItemStage, string> = {
  ideas: 'border-t-zinc-400',
  prioritized: 'border-t-violet-500',
  in_development: 'border-t-amber-500',
  dogfooding: 'border-t-cyan-500',
  beta: 'border-t-blue-500',
  on_hold: 'border-t-slate-500',
  ga: 'border-t-emerald-500',
  internal: 'border-t-purple-500',
  deprecated: 'border-t-red-500',
};

export const STAGE_DROP_TINT: Record<ProductItemStage, string> = {
  ideas: 'bg-zinc-500/5',
  prioritized: 'bg-violet-500/5',
  in_development: 'bg-amber-500/5',
  dogfooding: 'bg-cyan-500/5',
  beta: 'bg-blue-500/5',
  on_hold: 'bg-slate-500/5',
  ga: 'bg-emerald-500/5',
  internal: 'bg-purple-500/5',
  deprecated: 'bg-red-500/5',
};

export const PRIORITY_LABELS: Record<ProductItemPriority, string> = {
  p0: 'P0',
  p1: 'P1',
  p2: 'P2',
  p3: 'P3',
};

export const PRIORITY_COLORS: Record<ProductItemPriority, 'red' | 'orange' | 'yellow' | 'gray'> = {
  p0: 'red',
  p1: 'orange',
  p2: 'yellow',
  p3: 'gray',
};

export const PRIORITY_OPTIONS: { id: ProductItemPriority | 'none'; label: string }[] = [
  { id: 'none', label: 'No priority' },
  { id: 'p0', label: 'P0' },
  { id: 'p1', label: 'P1' },
  { id: 'p2', label: 'P2' },
  { id: 'p3', label: 'P3' },
];
